import React, { useRef } from 'react';
import Draggable from 'react-draggable';
import { useSelector } from 'react-redux';

import { CELL_HEIGHT } from '../const';
import { RootState } from '../store';
import { ItemTaskType, TaskPositionType } from '../types';

interface ICalendarTaskBorder {
    task: TaskPositionType;
    typeBorder: 'up' | 'down';
    cellWidth: number;
    saveDragResult: (taskId: string) => void;
    handleDragResize: (e: any, data: any, taskId: string, direction: 'up' | 'down') => void;
    startValueY: React.MutableRefObject<number>;
    heightBeforeDrag: React.MutableRefObject<number>;
    rowBeforeDrag: React.MutableRefObject<number>;
}

const CalendarTaskBorder: React.FC<ICalendarTaskBorder> = ({
    task,
    cellWidth,
    saveDragResult,
    handleDragResize,
    heightBeforeDrag,
    rowBeforeDrag,
    startValueY,
    typeBorder,
}) => {
    const currentTask = useSelector<RootState, ItemTaskType | null>((state) => state.calendar.currentTask);

    const taskBorderRef = useRef<HTMLDivElement>(null);

    const isTopBorder = typeBorder === 'up';

    return (
        <Draggable
            key={`border-${typeBorder}-${task.id}`}
            bounds={'parent'}
            grid={[cellWidth, CELL_HEIGHT]}
            position={{
                x: task.col * cellWidth,
                y: (isTopBorder ? task.row : task.row + task.height) * CELL_HEIGHT,
            }}
            onStart={(e, data) => {
                startValueY.current = data.y;
                heightBeforeDrag.current = task.height;
                rowBeforeDrag.current = task.row;
            }}
            onDrag={(e, data) => {
                handleDragResize(e, data, task.id, typeBorder);
            }}
            onStop={() => saveDragResult(task.id)}
            nodeRef={taskBorderRef}
        >
            <div
                ref={taskBorderRef}
                style={{
                    position: 'absolute',
                    height: 5,
                    width: cellWidth / task.colCount - task.marginLeft,
                    left: task.marginLeft + (task.colShow - 1) * (cellWidth / task.colCount),
                    backgroundColor: isTopBorder ? '#11ff1100' : '#f700ff00', // color needs for test positioning markers of moving border
                    cursor: 'ns-resize',
                    marginTop: isTopBorder ? 0 : -5,
                    zIndex: currentTask?.id === task.id ? task.zIndex + 100 : task.zIndex,
                }}
            ></div>
        </Draggable>
    );
};

export default CalendarTaskBorder;
